import { render, staticRenderFns } from "./chat-gpt.vue?vue&type=template&id=5c1e4fbf&lang=pug&"
import script from "./chat-gpt.vue?vue&type=script&lang=js&"
export * from "./chat-gpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports